import React,{useState,useEffect} from 'react';
import dayjs from 'dayjs';
import styled from 'styled-components';
import { Form, Input,InputNumber, Button, Select, Radio, Checkbox, DatePicker } from 'antd';
import { v4 as uuidv4 } from 'uuid';
import {generateFormFields} from 'components/table/form';
import _ from 'lodash';

const Container = styled.div`
  .ant-form-item-label >label {
    text-wrap: pretty;
    line-height: 14px;
  }
   .ant-form-item-label >label.ant-form-item-required:not(.ant-form-item-required-mark-optional)::before {   
    display: contents;       
  }
`;

export default ({ form:_form,key,schema,parentData, data,setData,showSubmit=false,errors}) => {
  
  // const [form] = Form.useForm();
  const [form] = _form?[_form]: Form.useForm();

  useEffect(() => {
    if (data) {
      // Handle date values to ensure they are not empty or undefined
      const intialData = { ...data };
      for (const key in schema.properties) {
        if (schema.properties[key]?.format === 'uuid')intialData[key] = uuidv4();        
      }
      for (const key in data) {
        if (schema.properties[key]?.format === 'date') {
          intialData[key] = null;
          dayjs(data?.[key]);
        }
       
      }
      form.setFieldsValue(intialData);
      
    }
  }, [data, schema]); 
  
  const onFinish = (values) => {    
    
    
    const valuesWithDateString = { ...values };
    for (const key in values) {
      if (schema.properties[key]?.format === 'date' && values[key]) {
        valuesWithDateString[key] = dayjs(values[key]).format('YYYY-MM-DD');
      }
    }
    
    return setData(valuesWithDateString);
  };
  
      
  const tailFormItemLayout = {
    wrapperCol: {
      xs: {
        span: 24,
        offset: 0,
      },
      sm: {
        span: 12,
        offset: 12,
      },
    },
  };
  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 12 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 12 },
    },
  };
  
  return (
    <Container>
      <Form 
        {...formItemLayout}
        form={form} 
        name={key||"form"}
        onFinish={onFinish}  
        onFinishFailed={(values,errorFields)=>console.log(values,errorFields)}
        
        >
        {!_.isEmpty(schema) && generateFormFields({form,schema,parentData,tailFormItemLayout})}
          {showSubmit &&
            <Form.Item {...tailFormItemLayout}>
             
              <Button type="primary" htmlType="submit" >
                OK
              </Button>
            
            </Form.Item>
          }
      </Form>      
    </Container>
  );
};